import React from 'react';
import { View } from 'react-native';
import { createStyleSheet } from '../../../../utils';
import { useStyleSheet } from '../../../../hooks';
export const Indicators = () => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(View, { style: styles.container },
        React.createElement(View, { style: [styles.indicator, styles.first, { right: '100%' }] }),
        React.createElement(View, { style: [styles.indicator, styles.centered, { right: '75%' }] }),
        React.createElement(View, { style: [styles.indicator, styles.centered, { right: '50%' }] }),
        React.createElement(View, { style: [styles.indicator, styles.centered, { right: '25%' }] }),
        React.createElement(View, { style: [styles.indicator, { right: '0%' }] })));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        alignSelf: 'flex-end',
        width: '100%',
        height: size.I
    },
    indicator: {
        color: color.invert2.p56,
        position: 'absolute',
        width: size.L,
        backgroundColor: color.invert2.p4,
        borderRadius: 6,
        height: size.H
    },
    first: {
        marginRight: -size.L
    },
    centered: {
        marginRight: -size.L / 2
    }
}));
//# sourceMappingURL=Indicators.js.map